import React from 'react';
import { FormattedMessage } from 'react-intl';
import { node } from 'prop-types';

import { Wrappers, ErrorCard } from '../components';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // componentDidCatch(error, errorInfo) {
  //   // You can also log the error to an error reporting service
  //   logErrorToMyService(error, errorInfo);
  // }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    // fallback UI for errors
    if (hasError) {
      return (
        <Wrappers.Layout>
          <ErrorCard
            title={<FormattedMessage id="title.issue" />}
            description={
              <FormattedMessage
                id="description.issue"
                values={{
                  break: <br />,
                  email: (
                    <a href="mailto:agidealersupport@aggrowth.com">
                      agidealersupport@aggrowth.com
                    </a>
                  )
                }}
              />
            }
          />
        </Wrappers.Layout>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: node.isRequired
};

export default ErrorBoundary;
